export default __webpack_public_path__ + "static/media/nudge.4125bf0e.mp3";